import React, { Component } from "react"

import { Checkbox } from "ui"

export default class CheckboxAttribute extends Component {
    render() {
        return <Checkbox value={!!this.props.value} onChange={this.props.onChange} />
    }
}



// WEBPACK FOOTER //
// ./src/features/editor/attributes/items/form/Checkbox.js